import type { ErrorInfo } from "../types";

type RawErrorDataProps = {
  errorInfo: ErrorInfo;
};

export function RawErrorData({ errorInfo }: RawErrorDataProps) {
  const rawError = errorInfo.devDetails.rawError;

  if (!rawError) {
    return null;
  }

  return (
    <div>
      <h4 className="mb-2 font-semibold text-red-800">Raw Error Data:</h4>
      <pre className="max-h-64 w-full overflow-x-auto overflow-y-auto rounded bg-white p-3 text-xs text-gray-700">
        <code>{rawError}</code>
      </pre>
    </div>
  );
}
